import { bootstrapRealtime } from '../../app/zionApp.ts'
import {
  deviceLinkReceiverPanelHtml,
  mountDeviceLinkReceiverPanel,
  shouldShowDeviceLinkQrOnAuth,
} from '../../deviceLink/deviceLinkReceiverPanel.ts'
import { t } from '../../i18n/index.ts'
import { appendBlocks } from '../dom.ts'
import { navigate } from '../router.ts'

/** PC / tablet: mostra QR verde da inquadrare col telefono. */
export async function renderLinkDeviceScreen(root: HTMLElement): Promise<void> {
  if (!shouldShowDeviceLinkQrOnAuth()) {
    navigate('linkDeviceScan')
    return
  }

  root.innerHTML = ''
  appendBlocks(
    root,
    `
      <header class="topbar premium-topbar">
        <button type="button" class="icon-btn" id="btn-back">←</button>
        <h2 class="topbar-title">${t('link_device_title')}</h2>
      </header>
      ${deviceLinkReceiverPanelHtml(true)}
    `,
  )

  let cancelPairing = (): void => {}

  root.querySelector('#btn-back')!.addEventListener('click', () => {
    cancelPairing()
    navigate('settings')
  })

  const panel = root.querySelector('#device-link-recv') as HTMLElement | null
  if (!panel) return

  cancelPairing = await mountDeviceLinkReceiverPanel(panel, {
    onComplete: async () => {
      cancelPairing()
      await bootstrapRealtime()
      navigate('home')
    },
    onSkip: () => {
      cancelPairing()
      navigate('settings')
    },
  })
}
